export default "__VITE_ASSET__DtVtUREy__"